import CategoryTilesBlock from './categoryTilesBlock'

export default CategoryTilesBlock
